import { middlewareApi } from "../../middlewares/middlewareApi";
import mainApi from "../../api/mainApi";
import { UserInfo } from "../../interfaces/auth/user.interface";
import { setAuthState } from "../../slices/auth/authSlice";
import { AxiosError } from "axios";

const authService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<
      any,
      {
        email: string;
        contrasenia: string;
      }
    >({
      queryFn: async ({ email, contrasenia }, { dispatch }) => {
        try {
          const { data } = await mainApi.post<UserInfo>("auth", {
            email,
            contrasenia,
          });

          if (data) {
            dispatch(
              setAuthState({
                isLogged: true,
                userInfo: data,
              })
            );
            localStorage.setItem("token", data.token);
            localStorage.setItem(
              "token-init-date",
              String(new Date().getTime())
            );
            localStorage.setItem("user", JSON.stringify(data));
          }

          return { data };
        } catch (error) {
          let err = error as AxiosError;

          //Handle error message from back
          if (err.response && err.response.data) {
            let errResponse: any = err.response.data;
            if (errResponse && "ok" in errResponse) {
              return {
                error: {
                  status: 500,
                  data: errResponse.msg,
                },
              };
            }
          }

          return {
            error: {
              status: 500,
              data: err.message,
            },
          };
        }
      },
    }),
  }),
});

export const { useLoginMutation } = authService;
